<template>
    <div>
        <b-card class="p-3">
            <b-col class="page-block"><strong>{{ $translate('page') }}: {{ currentPage }} {{ $translate('of') }}
                    {{ Math.ceil(rows / itemsPerPage) }} {{ $translate('total') }}:
                    {{ rows }}</strong></b-col>
            <b-card-header class="p-0">
                <b-row>
                    <div class="pe-2">
                        <button :disabled="!hasPermissionUpdate && !hasPermissionCreate
                            " class="btn blue-button" v-b-tooltip.hover :title="$translate('bulk_transfer')"
                            @click="bulkTransfer()">
                            <img src="@/assets/images/icon/bulk-transfer.svg" />
                        </button>
                    </div>
                    <b-col md="2" class="ps-0">
                        <div class="d-flex">
                            <button class="btn blue-button me-2" @click="shouldShowFilters = !shouldShowFilters">
                                <span style="white-space: nowrap">
                                    {{ $translate('filters') }}
                                    <b-icon :icon="`chevron-${shouldShowFilters ? 'up' : 'down'
                                        }`"></b-icon>
                                </span>
                            </button>
                            <button class="btn blue-button" variant="light" size="sm" @click="resetFilters"
                                v-b-tooltip.hover :title="$translate('reset_filters')">
                                <b-icon icon="arrow-repeat" variant="dark"></b-icon>
                            </button>
                        </div>
                    </b-col>
                    <b-col class="d-flex justify-content-end">
                        <slot></slot>
                    </b-col>
                </b-row>
                <SectionItemsQueryFilter class="mt-12" :locations="locations" :items="sectionMasterItems" :types="types"
                    :officers="users" v-show="shouldShowFilters" ref="queryFilter" v-model="filters"
                    :disabled-officers="!hasPermissionView" :officer-option="officerOption" />
            </b-card-header>
            <b-card-body class="p-0 mt-3">
                <b-table :items="sectionMasterItems" :fields="itemFields" hover :busy="tableLoading" :filter="filters"
                    responsive :per-page="itemsPerPage" :current-page="currentPage" selectable @row-selected="onRowSelected"
                    ref="selectable">
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>{{ $translate('loading') }}</strong>
                        </div>
                    </template>
                    <template #head(check)>
                        <!-- {{itemsPerPage}}{{selectedsectionMasterItems}} -->
                        <b-form-checkbox v-if="sectionMasterItems.length > 0" :checked="itemsPerPage ===
                            selectedsectionMasterItems.length
                            " @change="toggleAllRow()"></b-form-checkbox>
                    </template>
                    <template #cell(check)="{ rowSelected, index }">
                        <b-form-checkbox :checked="rowSelected" @change="toggleRow(index, rowSelected)"></b-form-checkbox>
                    </template>
                    <template #cell(Warehouse)="{ item }">
                        <div v-html="getInventoryLocation(item)"></div>
                    </template>
                    <template #cell(actions)="{ item }">
                        <b-button :disabled="!hasPermissionUpdate && !hasPermissionCreate
                            " class="mr-2 text-black" @click="transfer(item)" variant="pink-button">
                            <img src="@/assets/images/icon/transfer.svg" />
                        </b-button>
                    </template>
                </b-table>
                <b-row>
                    <b-col>
                        <b-pagination class="justify-content-center mt-4" v-model="currentPage" :disabled="tableLoading"
                            :total-rows="rows" :per-page="itemsPerPage" aria-controls="customerTable"
                            :prev-text="$translate('previous')" :next-text="$translate('next')" pills
                            align="center"></b-pagination>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import _ from 'lodash'
import permissionsMixins from '@/mixins/permissionsMixins'
import SectionItemsQueryFilter from './SectionItemsQueryFilter.vue'

import popupMixins from '@/mixins/popupMixins'
import showItemHelper from '@/mixins/showItemHelper'
import importMixins from '@/mixins/importMixins'
export default {
    name: 'inventoryTransfer-ListItems',
    components: { SectionItemsQueryFilter },
    props: ['type', 'title', 'item'],
    mixins: [popupMixins, showItemHelper, importMixins, permissionsMixins],

    data() {
        return {
            tableLoading: false,
            disabled: false,
            filters: {
                location_id: null,
                order_item_type_id: null,
                officer_id: null,
                product_search: null,
                section_search: null,
                quantity: null,
                quantityType: 1,
            },
            itemsPerPage: 15,
            currentPage: 1,
            selectedsectionMasterItems: [],
            islocationSection: false,
            isOfficerSection: false,
            istypeSection: false,
            isProduct: false,
            isSectionSection: false,
            section_id: null,
            user_id: null,
            location_id: null,
            shouldShowFilters: false,
            bulkAction: 'none',
            type_id: null,
            reportType: 'section_items',
        }
    },
    mounted() {
        ///this.resetFilters()
    },
    computed: {
        itemFields() {
            return[
                "check",
                {
                    key: 'actions',
                    label: this.$translate('actions'),
                },
                {
                    key: 'name',
                    label: this.$translate('name'),
                },
                {
                    key: 'ext_reference_code',
                    label: this.$translate('code'),
                },
                {
                    key: 'order_item_type_id',
                    label: this.$translate('type'),
                    formatter: (value, key, item) =>
                        item.type && item.type.name,
                },

                {
                    key: 'Warehouse',
                    label: this.$translate('inventory_location'),
                },

                {
                    key: 'vendor_id',
                    label: this.$translate('vendor'),
                    formatter: (value, key, item) =>
                        item.vendor && item.vendor.name,
                },

                {
                    key: 'uom',
                    label: this.$translate('uom'),
                    formatter: (value, key, item) => item.uom,
                },
                {
                    key: 'selling_price',
                    label: this.$translate('price'),
                    formatter: (value, key, item) => item.selling_price,
                },
                {
                    key: 'quantity',
                    label: this.$translate('qty_on_hand'),
                    formatter: (value, key, item) =>
                        item.section && item.section.quantity_on_hand,
                },
            ]
        },
        officerOption() {
            return '----officers----'
        },
        locations() {
            return this.$store.state.locations.locations.filter(
                x => x.is_warehouse || x.sections.some(y => !y.is_officer)
            )
        },
        defaultLocationId() {
            if (this.locations.length) {
                return this.locations[0].id
            }
            return null
        },
        defaultProductSearch() {
            return 'a'
        },
        sections() {
            const { location_id } = this
            return (
                (
                    this.$store.state.locations.locations.find(
                        x => x.id == location_id
                    ) || {}
                ).sections || []
            ).filter(x => !x.is_officer)
        },
        sectionMasterItems() {
            const _items = this.$store.state.masterItem.section_items
            const data = []
            for (const masteritem of _items) {
                if (masteritem.sections.length == 0) {
                    data.push({
                        ...masteritem,
                        section: { quantity_on_hand: 0 },
                    })
                } else {
                    for (const section of masteritem.sections) {
                        data.push({ ...masteritem, section })
                    }
                }
            }
            return this.sectionFilterdData(data)
        },
        users() {
            return this.$store.getters['users/sorted_officers']
        },
        types() {
            return this.$store.state.itemType.items.filter(
                x => !x.is_discount && !x.is_task
            )
        },
        rows() {
            return this.sectionMasterItems.length
        },
    },
    watch: {
        'filters.order_item_type_id': function () {
            this.doSearch(true)
        },

        'filters.product_search': _.debounce(function () {
            this.doSearch(true)
        }, 200),

        'filters.section_search': function () {
            this.doSearch()
        },

        'filters.quantity': function () {
            this.doSearch()
        },

        'filters.quantityType': function () {
            this.doSearch()
        },

        'filters.officer_id': function () {
            this.doSearch()
        },

        'filters.location_id': function () {
            this.doSearch()
        },

        report_loading: function (val) {
            this.$emit('report-state', val)
        },
        user_id: function (id) {
            const user = this.users.find(x => x.id == id)
            if (user) this.section_id = user.location_section_id
            else this.section_id = null
        },

        section_id: function (id) {
            if (id) this.$store.dispatch('masterItem/fetchBySection', id)
            else this.$store.commit('masterItem/SET_SECTION_ITEMS', [])
        },
        isOfficerSection: function () {
            this.section_id = null
            this.location_id = null
            this.user_id = null
        },
    },
    created() { },

    methods: {
        sectionFilterdData(sectiondata) {
            //filter out non warehouses
            const {
                quantityType,
                quantity,
                location_id,
                officer_id,
                order_item_type_id,
                product_search,
                section_search,
            } = this.filters

            let data = [...(sectiondata || [])].filter(
                x =>
                    !x.section.location_section ||
                    x.section.location_section.is_officer ||
                    x.section.location_section.officers.length ||
                    x.section.location_section.location.is_warehouse
            )

            if (parseInt(location_id, 10)) {
                data = data.filter(
                    x =>
                        x.section.location_section &&
                        x.section.location_section.location.id == location_id &&
                        x.section.location_section.location.is_warehouse &&
                        x.section.location_section.officers.length == 0
                )
            }

            if (location_id === this.officerOption) {
                data = data.filter(
                    x =>
                        x.section.location_section &&
                        (x.section.location_section.is_officer ||
                            x.section.location_section.officers.length)
                )
            }
            if (officer_id) {
                data = data.filter(
                    x =>
                        x.section.location_section &&
                        x.section.location_section.officers[0] &&
                        x.section.location_section.officers[0].id == officer_id
                )
            }
            if (order_item_type_id) {
                data = data.filter(x => x.type.id == order_item_type_id)
            }
            if (product_search) {
                data = data.filter(
                    x =>
                        x.name
                            .toLowerCase()
                            .indexOf(product_search.toLowerCase()) != -1
                )
            }
            if (section_search) {
                data = data.filter(
                    x =>
                        x.section.location_section &&
                        x.section.location_section.name
                            .toLowerCase()
                            .indexOf(section_search.toLowerCase()) != -1
                )
            }

            if (quantity || quantity === 0) {
                if (quantityType == 1) {
                    data = data.filter(
                        x => x.section.quantity_on_hand == quantity
                    )
                } else if (quantityType == 2) {
                    data = data.filter(
                        x => x.section.quantity_on_hand < quantity
                    )
                } else if (quantityType == 3) {
                    data = data.filter(
                        x => x.section.quantity_on_hand > quantity
                    )
                }
            }

            return data
        },
        resetFilters() {
            this.filters = {
                location_id: null,
                order_item_type_id: null,
                officer_id: null,
                product_search: null,
                section_search: null,
                quantity: null,
                quantityType: 1,
            }
            this.doSearch()
        },
        getInventoryLocation(item) {
            if (!item.section.location_section) {
                return ''
            }

            if (item.section.location_section.officers.length) {
                return (
                    `<strong>${this.$translate('officer')}</strong>: ` +
                    (item.section.location_section.officers[0] &&
                        item.section.location_section.officers[0].first_name +
                        ' ' +
                        item.section.location_section.officers[0].last_name)
                )
            } else {
                return (
                    item.section.location_section.location.name +
                    `:` +
                    item.section.location_section.name
                )
            }
        },

        async doSearch(remoteSearch = false) {
            let {
                filters: {
                    order_item_type_id,
                    product_search,
                    location_id,
                    officer_id,
                    section_search,
                    quantity,
                },
            } = this

            if (
                !location_id &&
                !order_item_type_id &&
                !officer_id &&
                !product_search &&
                !section_search &&
                !(quantity || quantity === 0) &&
                !remoteSearch
            ) {
                this.$store.commit('masterItem/SET_SECTION_ITEMS', [])
            } else {
                if (!this.sectionMasterItems.length || remoteSearch) {
                    try {
                        this.tableLoading = true
                        await this.$store.dispatch('masterItem/fetchSection', {
                            filters: { product_search, order_item_type_id },
                        })
                    } catch (err) {
                        console.log('query err', err)
                    } finally {
                        this.tableLoading = false
                    }
                }
            }
        },
        getItems(items) {
            this.$nextTick(() => {
                this.$store.dispatch('masterItem/fetchSelectedItems', items)
                this.doToast(this.$translate('success'), this.$translate('transfer_success_alert'), 'success')
            })
        },
        getSectionQuantity(sections, section_id) {
            sections = sections || []
            if (section_id) {
                const section = sections.find(
                    x => x.location_section_id === section_id
                )
                if (!section) return 0
                return section.quantity_on_hand
            } else {
                return sections.reduce((_sum, section) => {
                    _sum += section.quantity_on_hand
                }, 0)
            }
        },
        info(item, index, button) {
            this.infoModal.title = `Row index: ${index}`
            this.infoModal.content = JSON.stringify(item, null, 2)
            this.$root.$emit('bv::show::modal', this.infoModal.id, button)
        },
        resetInfoModal() {
            this.infoModal.title = ''
            this.infoModal.content = ''
        },
        onRowSelected(items) {
            this.selectedsectionMasterItems = items
        },
        selectAllRows() {
            this.$refs.selectable && this.$refs.selectable.selectAllRows()
        },
        clearSelected() {
            this.$refs.selectable && this.$refs.selectable.clearSelected()
        },
        clearAllSelect() {
            this.selectedsectionMasterItems = []
        },
        toggleRow(index, rowSelected) {
            if (rowSelected) this.$refs.selectable.unselectRow(index)
            else this.$refs.selectable.selectRow(index)
        },
        toggleAllRow() {
            if (this.itemsPerPage === this.selectedsectionMasterItems.length)
                this.$refs.selectable && this.$refs.selectable.clearSelected()
            else this.$refs.selectable.selectAllRows()
        },
        transfer(items) {
            this.$store.commit('masterItem/SET_TRANSFER_ITEMS', [items])
        },
        bulkTransfer() {
            if (this.selectedsectionMasterItems.length > 0) {
                this.$store.commit(
                    'masterItem/SET_TRANSFER_ITEMS',
                    this.selectedsectionMasterItems
                )
            } else {
                this.doToast(
                    this.$translate('error'),
                    this.$translate(`select_for_bulk_transfer`),
                    'danger',
                )
            }
        },
    },
}
</script>